var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDarkLightModeMobile = function SvgDarkLightModeMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 54302",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108492",
    d: "M23 0A23 23 0 1 1 0 23 23 23 0 0 1 23 0Z",
    fill: "rgba(239,240,246,0.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "noun-night-mode-2434960",
    d: "M31.724 26.932a9.328 9.328 0 0 1-6.924 4.7 8.958 8.958 0 0 1-1.269.087 9.4 9.4 0 0 1-4.983-17.34.672.672 0 0 1 .94.9 8.059 8.059 0 0 0 8.1 11.913 7.957 7.957 0 0 0 3.19-1.162.672.672 0 0 1 .947.9Z",
    fill: "#eff0f6"
  })));
};
export default SvgDarkLightModeMobile;